/**
 * TransitionMatrixPage — Brief 4 (Gestor) · Matriz de Transição entre Playbooks
 * (ADR-031 Eixo O · config declarativa por par de playbooks).
 *
 * Rota: /admin/ia/matriz-transicao. Leitura + edição de policy por célula
 * sobre /v1/playbooks (a policy vive inline em cada playbook — sem recurso/model
 * próprio). Padrão D-B (defense-in-depth): gate próprio na página (`playbook-read`),
 * além da query gateada no hook. A edição é gateada em `playbook-author` na view.
 *
 * ATENÇÃO: NÃO confundir com `ai-transition` (runtime do transition-agent, ADR-031)
 * nem com o histórico PlaybookTransitionProposal. Esta tela CONFIGURA as políticas.
 */

import { CapabilityLockedBanner } from '@lume/ui-components';

import { TransitionMatrixView } from '../features/transition-matrix/TransitionMatrixView';
import { useMatrixPlaybooks } from '../features/transition-matrix/use-transition-matrix';
import { useCapability } from '../hooks/use-capability';

import '../features/transition-matrix/transition-matrix.css';

export function TransitionMatrixPage(): JSX.Element {
  const canRead = useCapability('playbook-read');

  // D-B — gate próprio, não confiar só na rota protegida.
  if (!canRead) {
    return (
      <div className="transition-matrix-screen transition-matrix-screen--gate">
        <CapabilityLockedBanner
          capability="playbook-read"
          tierMin="solo"
          fallbackMessage="A matriz de transição entre playbooks é restrita a perfis de gestão — fale com o administrador do tenant."
        />
      </div>
    );
  }

  return <TransitionMatrixPageInner />;
}

function TransitionMatrixPageInner(): JSX.Element {
  const canManage = useCapability('playbook-author');
  const list = useMatrixPlaybooks();

  if (list.isLoading) {
    return (
      <div className="transition-matrix-screen">
        <div className="tm-page">
          <p className="tm-muted">Carregando playbooks…</p>
        </div>
      </div>
    );
  }

  if (list.isError) {
    return (
      <div className="transition-matrix-screen">
        <div className="tm-page">
          <p className="tm-banner tm-banner--muted" role="alert">
            Falha ao carregar os playbooks.
          </p>
        </div>
      </div>
    );
  }

  return <TransitionMatrixView playbooks={list.data} canManage={canManage} />;
}
